import dayjs from "dayjs"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

const header = [
	[
		"Template 06 - Number of policies by four underwriting/ re-underwriting results, by age and sex of Insured Person"
	],
	["Age", "Sex", "Standard Plan", "", "", "", "Flexi Plan"],
	[
		"",
		"",
		"Standard Offer",
		"With Premium Loading only",
		"With CBE only",
		"With Premium Loading and CBE",
		"Standard Offer",
		"With Premium Loading only",
		"With CBE only",
		"With Premium Loading and CBE"
	]
]

// Return calculated age
const getAge = policy => {
	const dateOfBirth = policy?.contractInsured?.[0]?.dateOfBirth
	const currentYear = dayjs().year()
	const yearOfBirth = dayjs(dateOfBirth).year()
	return currentYear - yearOfBirth
}

const rows = payload => {
	let output = []
	for (let i = 1; i < 100; i++) {
		output.push([
			i,
			"M",
			// standard plans
			countStandardOffer(i, "male", payload, "S00027"),
			countOfferWithLoadings(i, "male", payload, "S00027"),
			countOfferWithExclusions(i, "male", payload, "S00027"),
			countOfferWithLoadingsAndExclusions(i, "male", payload, "S00027"),
			// flexi plans
			countStandardOffer(i, "male", payload, "F00038"),
			countOfferWithLoadings(i, "male", payload, "F00038"),
			countOfferWithExclusions(i, "male", payload, "F00038"),
			countOfferWithLoadingsAndExclusions(i, "male", payload, "F00038")
		])
	}
	for (let j = 1; j < 100; j++) {
		output.push([
			j,
			"F",
			// standard plans
			countStandardOffer(j, "female", payload, "S00027"),
			countOfferWithLoadings(j, "female", payload, "S00027"),
			countOfferWithExclusions(j, "female", payload, "S00027"),
			countOfferWithLoadingsAndExclusions(j, "female", payload, "S00027"),
			// flexi plans
			countStandardOffer(j, "female", payload, "F00038"),
			countOfferWithLoadings(j, "female", payload, "F00038"),
			countOfferWithExclusions(j, "female", payload, "F00038"),
			countOfferWithLoadingsAndExclusions(j, "female", payload, "F00038")
		])
	}
	return output
}

const countStandardOffer = (age, gender, payload, plan) => {
	return payload.filter(policy => {
		let insuredAge = getAge(policy)
		let insuredGender = policy?.contractInsured?.[0]?.gender
		let matchPlan = policy?.product?.productId?.plan?.includes(plan)
		if (
			policy.status === "ISSUED" &&
			insuredAge === age &&
			insuredGender === gender &&
			matchPlan
		) {
			return policy
		}
	}).length
}

const countOfferWithLoadings = (age, gender, payload, plan) => {
	return payload.filter(policy => {
		let insuredAge = getAge(policy)
		let insuredGender = policy?.contractInsured?.[0]?.gender
		let loadings = policy?.premium?.loadings?.length > 0 ? true : false
		let exclusions = policy?.exclusions?.length > 0 ? true : false
		let matchPlan = policy?.product?.productId?.plan?.includes(plan)
		if (
			policy.status === "ISSUED" &&
			insuredAge === age &&
			insuredGender === gender &&
			loadings === true &&
			exclusions === false &&
			matchPlan
		) {
			return policy
		}
	}).length
}

const countOfferWithExclusions = (age, gender, payload, plan) => {
	return payload.filter(policy => {
		let insuredAge = getAge(policy)
		let insuredGender = policy?.contractInsured?.[0]?.gender
		let loadings = policy?.premium?.loadings?.length > 0 ? true : false
		let exclusions = policy?.exclusions?.length > 0 ? true : false
		let matchPlan = policy?.product?.productId?.plan?.includes(plan)
		if (
			policy.status === "ISSUED" &&
			insuredAge === age &&
			insuredGender === gender &&
			exclusions === true &&
			loadings === false &&
			matchPlan
		) {
			return policy
		}
	}).length
}

const countOfferWithLoadingsAndExclusions = (age, gender, payload, plan) => {
	return payload.filter(policy => {
		let insuredAge = getAge(policy)
		let insuredGender = policy?.contractInsured?.[0]?.gender
		let loadings = policy?.premium?.loadings?.length > 0 ? true : false
		let exclusions = policy?.exclusions?.length > 0 ? true : false
		let matchPlan = policy?.product?.productId?.plan?.includes(plan)
		if (
			policy.status === "ISSUED" &&
			insuredAge === age &&
			insuredGender === gender &&
			loadings &&
			exclusions &&
			matchPlan
		) {
			return policy
		}
	}).length
}

const fetchData = async filterPayload => {
	const query = gql`
		query fetchTemplate06Payload($policyWhere: policyWhereInput) {
			policies(where: $policyWhere) {
				list {
					status
					product {
						productId {
							plan
						}
					}
					contractInsured {
						... on individual {
							gender
							dateOfBirth
						}
					}
					premium {
						loadings {
							id
						}
					}
					exclusions {
						id
					}
				}
			}
		}
	`
	const variables = {
		policyWhere: filterPayload
	}

	const res = await api({ query, variables })

	return res?.data?.policies?.list
}

export default async filterPayload => {
	const fetchedData = await fetchData(filterPayload)
	const workSheetData = [...header, ...rows(fetchedData)]
	const workSheetColumns = header[2].map(item => {
		return { wpx: 100 }
	})
	const workSheetMerges = [
		{
			s: { r: 0, c: 0 },
			e: { r: 0, c: 6 }
		},
		{
			s: { r: 1, c: 0 },
			e: { r: 2, c: 0 }
		},
		{
			s: { r: 1, c: 1 },
			e: { r: 2, c: 1 }
		},
		{
			s: { r: 1, c: 2 },
			e: { r: 1, c: 5 }
		},
		{
			s: { r: 1, c: 6 },
			e: { r: 1, c: 9 }
		}
	]
	return { workSheetData, workSheetColumns, workSheetMerges }
}
